import React, { ReactElement, ReactNode } from 'react';
import styled from 'styled-components';

type HelperTextTypes = 'error' | 'success' | 'default';

interface HelperTextProps {
  children: ReactNode;
  type?: HelperTextTypes;
}

interface HelperTextStyleProps {
  type: HelperTextTypes;
}

const Wrapper = styled.div<HelperTextStyleProps>`
  color: ${({ theme, type }) => {
    switch (type) {
      case 'success':
        return theme.colors.primary_600;

      case 'error':
        return theme.colors.alert_400;

      default:
        return theme.colors.black50;
    }
  }};
  ${({ theme }) => theme.fontTypes.type1};
  margin-top: 5px;
`;

const HelperText = ({ children, type = 'default' }: HelperTextProps): ReactElement => <Wrapper type={type}>{children}</Wrapper>;

export default HelperText;
